const getters = {
    activityLogs: (state) => {
        
        const data = state.activitylogs.filter(repository => {
            const date = new Date(repository.time).toISOString().slice(0,10);
            if(state.activityFilter.keyword || state.activityFilter.fromdate || state.activityFilter.todate){
                if((state.activityFilter.keyword && state.activityFilter.keyword != '') && (repository.activity.toLowerCase().indexOf(state.activityFilter.keyword.toLowerCase()) !== -1 || repository.user.toLowerCase().indexOf(state.activityFilter.keyword.toLowerCase()) !== -1 || repository.category.toLowerCase().indexOf(state.activityFilter.keyword.toLowerCase()) !== -1 || repository.user_email.toLowerCase().indexOf(state.activityFilter.keyword.toLowerCase()) !== -1 || repository.status.toLowerCase().indexOf(state.activityFilter.keyword.toLowerCase()) !== -1)){
                  return repository
                }else if(state.activityFilter.fromdate && (state.activityFilter.fromdate && state.activityFilter.fromdate != '' && state.activityFilter.todate == '') && (date == state.activityFilter.fromdate)){
                    return repository;
                }else if(state.activityFilter.todate && (state.activityFilter.todate && state.activityFilter.todate != '' && state.activityFilter.fromdate == '') && (date == state.activityFilter.todate)){
                    return repository;
                }else if(((state.activityFilter.fromdate && state.activityFilter.todate) && (state.activityFilter.fromdate != '' && state.activityFilter.todate != '')) && (date >= state.activityFilter.fromdate && date <= state.activityFilter.todate)){
                    return repository;
                }
              }else{
                return repository
              }
        });
        return data;
    },
};

export default getters;